const WorkspaceConfig = {
    collapse: false,
    disable: false,
    comments: false,
    trashcan: true,
    maxTrashcanContents: 0,
    horizontalLayout: true,
    theme: {
      componentStyles: {
        workspaceBackgroundColour: '#333',
        toolboxBackgroundColour: '#333',
        toolboxForegroundColour: '#FFF',
      },
    },
    grid: {
      spacing: 20,
      length: 3,
      colour: "#333",
      snap: false,
    },
    zoom: {
      controls: false,
      wheel: false,
      pinch: false,
    },
    move: {
      scrollbars: {
        horizontal: false,
        vertical: true,
      },
      drag: false,
      wheel: false,
    }
  }
  
  export {
    WorkspaceConfig
  }
  